<template>
  <div>
    <ContentWrap title="直播举报">
      <el-form :inline="true" class="mb8">
        <el-form-item label="举报用户">
          <LiveMemberUserSelect v-model="queryParams.informMemberId" select-class="!w-260px" />
        </el-form-item>
        <el-form-item label="举报房间">
          <LiveRoomIdSelect v-model="queryParams.informRoomId" select-class="!w-260px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery"><Icon icon="ep:search" />查询</el-button>
          <el-button @click="resetQuery"><Icon icon="ep:refresh" />重置</el-button>
        </el-form-item>
      </el-form>
    </ContentWrap>

    <ContentWrap>
      <el-table v-loading="loading" :data="list" border>
        <el-table-column label="编号" prop="id" width="80" />
        <el-table-column label="举报用户ID" prop="informMemberId" min-width="120" />
        <el-table-column label="举报房间ID" prop="informRoomId" min-width="120" />
        <el-table-column label="举报类型" prop="informTypeName" min-width="120" />
        <el-table-column
          label="举报内容"
          prop="informContent"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column label="状态" prop="informState" width="100">
          <template #default="scope">
            <el-tag
              :type="
                scope.row.informState === 1
                  ? 'success'
                  : scope.row.informState === 2
                    ? 'danger'
                    : 'warning'
              "
              >{{
                scope.row.informState === 1
                  ? '已处理'
                  : scope.row.informState === 2
                    ? '已驳回'
                    : '待处理'
              }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          min-width="180"
          :formatter="dateFormatter"
        />
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button link type="primary" @click="handleInformBtn(scope.row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        v-model:page="queryParams.pageNo"
        v-model:limit="queryParams.pageSize"
        @pagination="getList"
      />
    </ContentWrap>

    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="500px" append-to-body>
      <el-form
        ref="formRef"
        :model="form"
        :rules="withLiveInputLimits(rules, liveInputLimits)"
        label-width="100px"
      >
        <el-form-item label="处理状态" prop="informState">
          <el-radio-group v-model="form.informState">
            <el-radio :label="0">待处理</el-radio>
            <el-radio :label="1">已处理</el-radio>
            <el-radio :label="2">已驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="处理说明" prop="informHandleMessage">
          <el-input
            show-word-limit
            :maxlength="500"
            v-model="form.informHandleMessage"
            type="textarea"
            :rows="3"
            placeholder="请输入处理说明"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { withLiveInputLimits } from '@/utils/liveInputLimits'
const liveInputLimits = { informHandleMessage: 500 }

import { dateFormatter } from '@/utils/formatTime'
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { pageInform, handleInform } from '@/api/live/inform'
import LiveMemberUserSelect from '@/views/live/components/LiveMemberUserSelect.vue'
import LiveRoomIdSelect from '@/views/live/components/LiveRoomIdSelect.vue'

const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const dialogVisible = ref(false)
const dialogTitle = ref('')
const formRef = ref<any>(null)
const currentId = ref<number | undefined>(undefined)

const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  informMemberId: undefined as number | undefined,
  informRoomId: undefined as number | undefined
})

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryParams.informMemberId = undefined
  queryParams.informRoomId = undefined
  queryParams.pageNo = 1
  getList()
}

const form = reactive({
  informState: 0,
  informHandleMessage: ''
})

const rules = {
  informState: [{ required: true, message: '处理状态不能为空', trigger: 'change' }]
}

const getList = async () => {
  loading.value = true
  try {
    const data: any = await pageInform(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleInformBtn = (row: any) => {
  currentId.value = row.id
  form.informState = row.informState || 0
  form.informHandleMessage = row.informHandleMessage || ''
  dialogTitle.value = '处理举报'
  dialogVisible.value = true
}

const submitForm = async () => {
  await formRef.value?.validate()
  if (currentId.value === undefined) return
  await handleInform({
    id: currentId.value,
    informState: form.informState,
    informHandleMessage: form.informHandleMessage
  })
  ElMessage.success('处理成功')
  dialogVisible.value = false
  getList()
}

onMounted(() => {
  getList()
})
</script>
